import axios from 'axios';

export function httpMixin ({ $services }) {
  $services.register('http', axios);
}
